// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3X7av","boxTitle":"Qualiphy_boxTitle__3OpXe","box":"Qualiphy_box__2ugVo","toggleWrap":"Qualiphy_toggleWrap__3tspP"};